import React from "react";
import { DAY_NAMES, WorkingInterval, WorkingWeek } from "@fidget/common/utils/getWorkingHours";
import { WorkingDay } from "@fidget/common/models/workingDay";
import { WorkingHoursRow } from "../../workingHours/workingHoursRow";

interface Props {
  hours: WorkingWeek;
  onChange(dayIndex: number, interval: WorkingInterval): void;
}
export const WorkingHoursForm = ({ hours, onChange }: Props) => {
  const workingDays = hours.map((interval, i) => new WorkingDay(DAY_NAMES[i]!, interval));

  return (
    <div>
      {workingDays.map((day, index) => (
        <WorkingHoursRow
          day={day}
          onChange={(interval) => onChange(index, interval)}
          key={day.name}
        />
      ))}
    </div>
  );
};
